import { Typography, Button, Result as ResultAnt, Row, message } from "antd";
import Footer from "../../components/Footer";
import Header from "../../components/Header/Header";
import { useTranslation } from "react-i18next";
import { queryPayComplete } from "../../api/order";
import { useNavigate, useLocation } from "react-router";
import { useEffect, useRef, useState } from "react";
import {
  PayResultStatus,
  payWayList,
  SOURCE_ORDER_TYPE,
} from "../../utils/contants";
const { Text } = Typography;
import "./index.scss";
import { IS_MOBILE } from "@/utils/tool";
import { getUser } from "@/api/config";
import useQuit from "@/hooks/useQuit";

const default_count = 5;
const Result = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [data, setData] = useState<CompleteResponse>();
  const timer = useRef(null);
  // 倒计时秒数
  const [count, setCount] = useState(default_count);
  const [messageApi, contextHolder] = message.useMessage();
  const { quit } = useQuit();
  /**
   * 查询支付结果
   */
  const query = async () => {
    const res = await queryPayComplete<CompleteResponse>({
      transaction_id: queryParams.get("transaction_id"),
    });
    if (res.code === 0) {
      setData(res.data);
      if (IS_MOBILE) return;
      if (
        res.data.pay_status === PayResultStatus.Completed &&
        res.data.return_url
      ) {
        timer.current = setInterval(() => {
          setCount((count) => --count);
        }, 1000);
      }
      return;
    }
    if (res.code === 100003) {
      navigate(
        `/login?goto=${encodeURIComponent(location.pathname + location.search)}`,
      );
      return;
    }
  };

  const toPersonal = () => {
    const user = getUser();
    if (user?.temporary) {
      messageApi.error(t("为了您的账号安全，请验证登录"), () => {
        quit("/personal/order?tab=" + data.first_order_type);
      });
      return;
    }
    navigate("/personal/order?tab=" + data.first_order_type);
  };
  /**
   * 返回
   */
  const cancelHandle = () => {
    const orderId = localStorage.getItem("orderId");
    const sign = localStorage.getItem("sign");
    if (data.first_order_type === SOURCE_ORDER_TYPE.Pod) {
      navigate("/personal/order?tab=" + SOURCE_ORDER_TYPE.Pod);
      return;
    }
    navigate(`/pay-gateway?order-id=${orderId}&sign=${sign}`);
  };
  useEffect(() => {
    const transaction_id = queryParams.get("transaction_id");
    if (transaction_id) {
      query();
      return;
    }
  }, []);

  useEffect(() => {
    if (count <= 0) {
      clearInterval(timer.current);
      globalThis.location.href = data.return_url;
    }
  }, [count]);

  if (!data) return null;
  return (
    <div className="result-box">
      {contextHolder}
      <div>
        <Header></Header>
        <div className="result-content-box">
          <ResultAnt
            className="result-icon"
            style={{ paddingBottom: "0", paddingTop: 0 }}
            status={
              data.pay_status === PayResultStatus.Completed
                ? "success"
                : "error"
            }
            title={
              data.pay_status === PayResultStatus.Completed
                ? t("支付成功")
                : t("支付失败")
            }
            extra={[]}
          />
          {!IS_MOBILE &&
            data.pay_status === PayResultStatus.Completed &&
            data.return_url &&
            count > 0 && (
              <Row justify={"center"} style={{ marginBottom: "10px" }}>
                <Text type="secondary">{t("countdown", { count: count })}</Text>
              </Row>
            )}
          <div className="result-content">
            <div>
              {t("交易流水号")}: {data.transaction_id}
            </div>
            <div>
              {t("支付方式")}: {t(payWayList[data.pay_method]?.value)}
            </div>
            <div>
              {t("金额")}：¥ {data.pay_money.toFixed(2)}
            </div>
          </div>
          <div className="btn-box">
            {data.pay_status === PayResultStatus.Completed &&
              !IS_MOBILE &&
              !data.return_url && (
                <Button
                  type="primary"
                  ghost
                  size="large"
                  className="btn"
                  onClick={toPersonal}
                >
                  {t("查看详情")}
                </Button>
              )}
            {data.pay_status !== PayResultStatus.Completed && (
              <Button
                type="primary"
                ghost
                size="large"
                className="btn"
                onClick={cancelHandle}
              >
                {t("返回")}
              </Button>
            )}
          </div>
        </div>
      </div>
      {!IS_MOBILE && <Footer></Footer>}
    </div>
  );
};

export default Result;
